import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import api from "../../../../api"; // adjust path

const Gallery = () => {
  const [gallery, setGallery] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        const response = await api.get("/api/sitepages/alumni/gallery");
        const galleryData = response.data.gallery_data;

        if (galleryData) {
          setGallery(galleryData);
        }
      } catch (error) {
        console.error("Error fetching gallery:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, []);

  if (loading || !gallery || !gallery.images?.length) return null;

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="gallery my-0 my-md-5 pb-5 pt-3">
      <div className="container">
        <div className="alumni_side mt-5 mb-5">
          <h3 className="bg-white wow fadeIn" data-wow-duration="2s">
            {gallery.heading}
          </h3>
        </div>

        <div
          className="row d-flex justify-content-center align-items-center text-center wow fadeIn"
          data-wow-duration="2s"
        >
          <Slider {...settings} className="alumni-carousel w-100">
            {gallery.images.map((img, index) => (
              <div className="item px-2" key={index}>
                <img
                  src={`${process.env.REACT_APP_API_URL}/public/${img.src}`}
                  alt={img.alt || `Gallery Image ${index + 1}`}
                  className="w-100 img-fluid"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
